import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

export const POR = "Por confirmar";
export const mon = (v, m = "MXN") => (v === null || v === undefined ? POR : `${m === "USD" ? "US$" : "$"}${Number(v).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const pc = (v, d = 1) => (v === null || v === undefined ? POR : `${(v * 100).toFixed(d)}%`);
export const inp = "w-full rounded-xl border border-[#E2DDD5] bg-white px-3 py-2 text-sm focus:border-[#13315C] focus:outline-none";

export const Que = ({ t, testid }) => (
  <Popover><PopoverTrigger asChild><button type="button" className="inline-flex items-center text-[#8C867A] transition-colors hover:text-[#E8643C]" aria-label="¿Qué significa?" data-testid={testid}><HelpCircle size={13} /></button></PopoverTrigger>
    <PopoverContent className="max-w-xs text-xs leading-relaxed"><p className="mb-1 font-semibold text-[#0B2545]">¿Qué significa?</p>{t}</PopoverContent></Popover>
);

export const Campo = ({ l, q, children }) => (
  <label className="block min-w-0 text-xs font-semibold text-[#5C5850]"><span className="mb-1 flex items-center gap-1">{l}{q && <Que t={q} />}</span>{children}</label>
);

const SEM = { verde: "#16C784", ambar: "#F0B90B", rojo: "#EA3943", gris: "#8C867A" };
export const Gauge = ({ cobertura, semaforo = "gris", colchon, testid }) => {
  const p = Math.max(0, Math.min(1, (cobertura || 0) / 1.5));
  const a = Math.PI * (1 - p);
  return (
    <svg viewBox="0 0 120 70" className="h-20 w-32" data-testid={testid} role="img" aria-label={`Cobertura ${cobertura ? pc(cobertura) : "sin dato"}`}>
      <path d="M10 60 A50 50 0 0 1 110 60" fill="none" stroke="#E2DDD5" strokeWidth="10" strokeLinecap="round" />
      {cobertura != null && <path d={`M10 60 A50 50 0 0 1 ${60 + 50 * Math.cos(a)} ${60 - 50 * Math.sin(a)}`} fill="none" stroke={SEM[semaforo]} strokeWidth="10" strokeLinecap="round" />}
      {colchon && <line x1={60 + 42 * Math.cos(Math.PI * (1 - colchon / 1.5))} y1={60 - 42 * Math.sin(Math.PI * (1 - colchon / 1.5))} x2={60 + 58 * Math.cos(Math.PI * (1 - colchon / 1.5))} y2={60 - 58 * Math.sin(Math.PI * (1 - colchon / 1.5))} stroke="#0B2545" strokeWidth="2" />}
      <text x="60" y="58" textAnchor="middle" className="fill-[#0B2545] text-[15px] font-bold">{cobertura == null ? "—" : pc(cobertura, 0)}</text>
    </svg>
  );
};

export const Checklist = ({ items, testid }) => (
  <ul className="space-y-1 text-xs" data-testid={testid}>{items.map((p) => <li key={p.key} className={`flex items-center gap-2 ${p.ok ? "text-emerald-700" : "text-[#5C5850]"}`} data-testid={`${testid}-${p.key}`}>
    <span className={`inline-block h-3.5 w-3.5 shrink-0 rounded-full border ${p.ok ? "border-emerald-600 bg-emerald-600" : "border-[#C9C2B6]"}`} />{p.label}</li>)}</ul>
);
